import { render, staticRenderFns } from "./LessonWatchCompany.vue?vue&type=template&id=81d59434"
import script from "./LessonWatchCompany.vue?vue&type=script&lang=js"
export * from "./LessonWatchCompany.vue?vue&type=script&lang=js"
import style0 from "./LessonWatchCompany.vue?vue&type=style&index=0&id=81d59434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports